import React from "react";
const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : React.createElement(React.Fragment, null, children);
export default ConditionalWrapper;
//# sourceMappingURL=ConditionalWrapper.js.map